import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import SinPermisos from '../../Components/SinPermisos/SinPermisos';

import CategoriasInventarioData from '../../Components/Admin/CategoriasInventarioData/CategoriasInventarioData';

import { fetchUsuario, getUsuario } from '../../Components/user';

export default function CategoriasInventario() {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);

    const usuarioLegued = getUsuario();

    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />

                <div className='container'>

                    {loading ? (
                        <></>
                    ) : usuarioLegued?.idUsuario ? (
                        <>
                            {usuarioLegued?.rol === 'admin' ? (
                                <CategoriasInventarioData />
                            ) : usuarioLegued?.rol === 'colaborador' ? (
                                <CategoriasInventarioData />
                            ) : (
                                <SinPermisos />
                            )}
                        </>
                    ) : (
                        <CategoriasInventarioData />
                    )}

                </div>
            </section>
        </div>
    );
}